import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";

const RecruiterRoute = memo(function RecruiterRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    if (session?.status === "unauthorized") {
      navigate("/");
      return;
    }

    if (
      session?.status === "authorized" &&
      session?.user?.role?.toLowerCase() === "admin"
    ) {
      navigate("/admin/dashboard");
      return;
    }

    if (
      session?.status === "authorized" &&
      session?.user?.role?.toLowerCase() === "user"
    ) {
      navigate("/");
      return;
    }
  }, [session?.status, session?.user?.role, navigate]);

  if (session?.status === "loading") {
    return <LoadingFallback />;
  }

  return session?.status === "authorized" &&
    session?.user?.role?.toLowerCase() === "recruiter"
    ? children
    : null;
});

export default RecruiterRoute;
